import companyProfileImage from "../../asset/companyProfile.png";
import chairmanImage from "../../asset/chairman.png";
import mdImage from "../../asset/managing-director.png";
import edImage from "../../asset/executive-director.png";

export const companyProfile: string = `Suhara Foreign Employment Agency is a premier executive search, recruitment consultants, HR outsourcing consultancy, manpower consultants, HR consultants, international recruitment agencies, foreign recruitment agencies, gulf recruitment agencies, human resource agency and placement consultants that partner with global clients to provide them with best talents from Nepal. We are a dedicated team of professional consultants offering top of the line executive search and selection services to diverse corporates of all sizes with varied business interests.
\n We have a track record of recruiting thousands of management professionals, technical and non technical personnel, skilled, semi-skilled and unskilled workers for clients in the Gulf and other Middle Eastern countries. Our professionals specialize in identifying Right People for the Right Job. We work in synergy with the clients to understand manpower requirements and procure best candidates with desired profles. Leveraging on the vast industry experience and network, we are well positioned to meet the all staffng needs within the shortest time frame.    
`;

export const chairmanMessage: string = `It is indeed my pleasure to take you towards a virtual tour of Suhara Foreign Employment Agency, which is one amongst the leaders in the recruitment Industry. 
 \n The world we live in is continuously transforming and competitive in human resource. Today’s challenge is to provide well-trained, potential and skillful manpower to the clients. One-time service is not sufficient to the clients but also providing continuous service after deployment is our objective to meet the Clients expectation. 
 \nI would like to bring it to our valued clients notice that the uhara Foreign Employment Agency with its competent staff member stands for quality service in order to meet required demand of the clients. 
 \nI always consider the fact that the human potentiality should be utilized to the maximum extent for the betterment of the world, hence our priority is always to bridge up the opportunities and the human resource. In short, we undertake responsibility to provide the right workers for the right job. I look forward to working with your esteemed organization in the days to come for mutual benefit.`;

export const managingDirectorMessage: string = `Thanks for giving your valuable time to look our profile. Employees are by far the most valued asset of our organization. When you’re in need of specialized, quick and affordable manpower services across the world, Suhara Foreign Employment Agency  is the name you can always trust for quality manpower recruitment. 
\nOur professional services will help you devise strategic plan, with a superb client based service to help your goal. We are one of the top listed manpower agency serving all types of industries. We are a leader in international recruitment services, multinational manpower consultancy services and career placements. 
\nAs a leading manpower consultant, we thrive to do our best, and can guarantee that you will leave satisfied with our services. We have served top companies in the middle-east and our recruiter’s team is on standby to serve you with innovative top talents solutions and quickly.
\n As one of the reliable international manpower consultants, we can do justice to all your needs in the most professional manner. We are growing day by day to meet our goal and fulfilling your needs.`;

export const executiveDirectorMessage: string = `It feels immense pleasure for me to lead Suhara Foreign Employment Agency, as one of the reliable and dynamic manpower recruitment agencies in Nepal. 
\nOn the behalf of Executive Director of this agency, I would like to extend my heartfelt gratitude to all of our clients, candidates and well-wishers. We always welcome you all in our company.
\nBeing government registered manpower agency in Nepal, we always follow the transparent, proven and legal procedure to recruit Nepalese manpower in overseas companies. You can feel absolutely safe to get recruited through our agency. We have thousands of satisfied clients and candidates. I once again, want to welcome you all. Your satisfaction is our motto.`;
export interface IcategoriesWeProvide {
  id: number;
  category: string;
  specification: string[];
}
export interface IOurMessageData {
  id: number;
  message: string;
  imageURL: string;
  messageTitle: string;
  messageFrom?: string;
}

export const ourMessageData: IOurMessageData[] = [
  {
    id: 1,
    message: companyProfile,
    imageURL: companyProfileImage,
    messageTitle: "Company Profile",
  },
  {
    id: 2,
    message: chairmanMessage,
    imageURL: chairmanImage,
    messageTitle: "Chairman Message",
    messageFrom: "Subash Pariyar",
  },
  {
    id: 3,
    message: managingDirectorMessage,
    imageURL: mdImage,
    messageTitle: "Managing Director Message",
    messageFrom: "Subba Syangbo",
  },
  {
    id: 4,
    message: executiveDirectorMessage,
    imageURL: edImage,
    messageTitle: "Executive Director Message",
    messageFrom: "Sumita Bhusal",
  },
];

export const categoriesWeProvide: IcategoriesWeProvide[] = [
  {
    id: 1,
    category: "HOTEL AND CATERING STAFF",
    specification: [
      "Manager and Asst. Manager",
      "Public Relation Officer",
      "Restaurant Captain",
      "Cook (Continental, Chinese, Indian and Arabic)",
      "Asst. Cooks",
      "Waiters/Stewards",
      "Fast Food Crew",
      "Food and Beverage Controller",
      "Food and Beverage Manager",
      "Bakers/Barman",
      "Kitchen Helpers",
      "Dishwasher men",
      "Laundrymen",
      "Pressmen/Janitors",
      "Housekeepers/Room makers",
      "Office Boys/Tea Boys/Bell Boys",
    ],
  },
  {
    id: 2,
    category: "Building Maintenance & Constructions",
    specification: [
      "Electricians/Helper",
      "Plumbers/Helper",
      "Welder- Electric & Gas",
      "Steel Fixers/Foremen",
      "Pipe Fitters/Helper",
      "Carpenters (Finishing and Shuttering)",
      "Electronic Technicians/Helper",
      "Electronic Technicians/Helper",
      "Painters (Spray Wall)/Helper",
      "Scaffolder/Helper",
      "Mason - Foremen",
      "Mason - Construction Helpers",
      "Mason - Brick Layers",
      "Mason - Tile/Marble Fitters",
    ],
  },
  {
    id: 3,
    category: "VEHICLE/HEAVY EQUIPMENT OPERATOR AUTO MECHANIC AND MAINTENANCE",
    specification: [
      "Light Vehicle Drivers",
      "Car/Van/Minibus Drivers",
      "Heavy Equipment Operators",
      "Truck/Lorry/Trailer/Forklift/ Crane Operator",
      "Motor/ Grader/Dozer/Backhoe Operator",
      "Roller Operators",
      "Bulldozer Operator",
      "Scrapper Operator",
      "Auto Mechanic",
      "Diesel Mechanics",
      "Heavy Duty Mechanic",
      "Wireless Technician",
      "Denter/Painter",
    ],
  },

  {
    id: 4,
    category: "AIR CONDITIONING (WINDOW TYPE,  SPLIT LEVEL & CENTRAL UNIT)",
    specification: [
      "HVAC Engineers ",
      "HVAC Foreman",
      "HVAC Supervisors",
      "HVAC Technicians",
    ],
  },
  {
    id: 5,
    category: "GARMENTS AND TEXTILE",
    specification: [
      "Production Managers",
      "Supervisors / Pattern Makers",
      " Cutting Masters / Tailors",
      "Checkers, Helpers",
    ],
  },
  {
    id: 6,
    category: "Engineering",
    specification: [
      "Electrical Engineer ",
      "Mechanical Engineer",
      "Electronic Engineer",
      "Civil Engineer",
    ],
  },
  {
    id: 7,
    category: "Security Guards",
    specification: [
      "Security Officer",
      "Security Supervisor",
      "Ex-British Gurkha Army",
      "Ex-Indian Gurkha Army ",
      "Ex-Nepalese Army",
      "Civil Security Guard",
      "Body Guard",
      "Watch Man  & many more.",
    ],
  },
  {
    id: 8,
    category: "Oil And Gas",
    specification: [
      "Piping Workers",
      "HSE Workers",
      "Instrumental Worker",
      "Electrical Workers",
      "Off Shore Workers",
      "Engineers / Project Managers",
      "Service Workers ",
      " Mechanical Workers.",
    ],
  },

  {
    id: 9,
    category: "AGRICULTURAL & FARMING GROUP",
    specification: [
      "Engineer Landscaping",
      "Engineer Irrigation",
      "Supervisors",
      "Foremen",
      "Gardeners/Farmers",
    ],
  },
  {
    id: 10,
    category: "OFFICE PERSONNEL MANAGEMENT",
    specification: [
      "Office Manager/Asst. Manager",
      "Manager - Marketing",
      "Sales, Admin.",
      "Accountants",
      "Cashiers",
      "Secretaries, Storekeeper",
      "Purchasers",
      "Clerks, Typists, Data Entry Operators",
    ],
  },
  {
    id: 11,
    category: "MANUFACTURING",
    specification: [
      "Automotive",
      "Petrochemical & Associated Products",
      "Building Products",
      "Consumer Products",
      "Forestry Pulp & Paper",
      "Machinery & Equipment",
      "Pharmaceuticals",
      "Industrial Products",
      "Defense",
    ],
  },
  {
    id: 12,
    category: "SUPERMARKET",
    specification: [
      "Salesman",
      "Check out Cashier",
      "Trolley Boys",
      "Shelves/ Rack Organizers",
      "Cleaners/Stockers/Merchan- diser",
    ],
  },
  {
    id: 13,
    category: "INFORMATION TECHNOLOGY",
    specification: [
      "Computer Engineer",
      "System Administrator",
      "Software Engineers",
      "Programmers",
      "System Analysts",
      "Network Administrators",
      "Data Entry Operators",
      "Computer Operators",
      "Computer Technicians",
      "Database Operators",
      "Data Entry Clerks",
    ],
  },
  {
    id: 14,
    category: "HOSPITAL STAFF GROUP",
    specification: [
      "Doctor: Gynecology (Surgeon)- MRCOG",
      " Doctor: Physician (General)- MD",
      "Doctor: Surgeon- MD",
      "Doctor: Gynecology- MS",
      "Doctor: Urology- MS",
      "Doctor: Skin (Skin & UD)- MD",
      "Doctor: Nephrology- MD",
      "RN Nurses (General Ward) - Diploma",
      "RN Nurses (Midwifery Gynecology) - Diploma",
      "RN Nurses (ICU) - Diploma",
      "RN Nurses(Surgery/ Operation Theatre)-Diploma",
      "Asst. Nurses (Cleaners) Male - Diploma",
      "Asst. Nurses (Cleaners) Female - Diploma",
      "Technician Lab - Diploma",
      " X-ray Technician - Diploma",
    ],
  },
];
